// zip.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'zip' })
export class ZipPipe implements PipeTransform {
  transform(array1: any[], array2: any[]): any[] {
    return array1.map((item, index) => ({
      item1: item,
      item2: array2[index]
    }));
  }
}